'use client'

import { useState } from 'react'
import auth0Client from '@/hooks/auth/auth0Client'
import { EXPLICIT_LOGOUT_SESSION_KEY } from '@/utils/authSession'

const LoginPage = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleLogin = async () => {
    setIsLoading(true)
    setError(null)
    sessionStorage.removeItem(EXPLICIT_LOGOUT_SESSION_KEY)

    try {
      await auth0Client.loginWithRedirect()
    } catch (loginError) {
      console.error('Login failed', loginError)
      sessionStorage.setItem(EXPLICIT_LOGOUT_SESSION_KEY, 'true')
      setError('Unable to start login. Please try again.')
      setIsLoading(false)
    }
  }

  return (
    <div className="fixed left-0 top-0 z-[500000000000] flex h-[100vh] w-[100vw] items-center justify-center bg-gray-50">
      <div className="flex w-[420px] flex-col items-start gap-lg rounded-xl border border-gray-200 bg-white p-xxl shadow-lg">
        <div className="flex flex-col gap-xs">
          <h1 className="text-title-xl text-gray-900">You are logged out</h1>
          <p className="text-text-md text-gray-500">Sign in again to continue to the admin portal.</p>
        </div>

        {error && <p className="text-text-sm text-red-600">{error}</p>}

        <button
          type="button"
          disabled={isLoading}
          onClick={handleLogin}
          className="h-[40px] rounded-md bg-primary-600 px-lg text-text-md font-medium text-white transition-colors hover:bg-primary-700 disabled:cursor-wait disabled:opacity-60"
        >
          {isLoading ? 'Signing in...' : 'Sign in'}
        </button>
      </div>
    </div>
  )
}

export default LoginPage
